import React from "react";
import {
	BsCheckCircle,
	BsExclamationTriangle,
	BsInfoCircle,
	BsXCircle
} from "react-icons/bs";
import "./inline-alert.css";

const iconByVariant = {
	info: BsInfoCircle,
	success: BsCheckCircle,
	warning: BsExclamationTriangle,
	error: BsXCircle
};

const InlineAlert = ({
	variant = "info",
	title,
	message,
	children,
	className = ""
}) => {
	const Icon = iconByVariant[variant] || BsInfoCircle;

	return (
		<div
			className={[
				"inline-alert",
				`inline-alert--${variant}`,
				className
			].filter(Boolean).join(" ")}
			role="alert"
		>
			<Icon className="inline-alert__icon" />

			<div className="inline-alert__content">
				{title && (
					<strong className="inline-alert__title">
						{title}
					</strong>
				)}

				{message && (
					<p className="inline-alert__message">
						{message}
					</p>
				)}

				{children}
			</div>
		</div>
	);
};

export default InlineAlert;